var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.813 11.116a2.75 2.75 0 1 1 3.889-3.889l.707.707 2.829 2.829 2.12 2.12a1.75 1.75 0 0 1-2.474 2.476l-4.95-4.95 1.06-1.06 4.95 4.95a.25.25 0 1 0 .354-.354l-2.121-2.122-2.829-2.828-.707-.707a1.25 1.25 0 1 0-1.768 1.768l2.122 2.12 1.414 1.415 2.829 2.828a2.25 2.25 0 1 0 3.181-3.182l-4.242-4.242 1.06-1.06 4.243 4.242a3.75 3.75 0 1 1-5.303 5.303l-2.829-2.828-1.414-1.415z",
    clipRule: "evenodd"
  })));
};
export default SvgAttach;